module.exports = __webpack_public_path__ + "static/img/biasfx2-tonecloud-2.4e668ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/biasfx2-tonecloud-2.jpg
// module id = zNBk
// module chunks = 12